<!-- 金融展下载页 -->
<template>
  <div class="dl-view">
    <img width="100%" height="100%" :src="imgUrl">
    <div class="download-button-view">
      <div class="open-app-view" @click="download">下载地址1</div>
      <div class="open-app-view" @click="download_two">下载地址2</div>
      <div class="download-app-view" @click="openApp">已下载打开APP</div>
    </div>
    <van-overlay :show="show" @click="show = false">
      <div class="tip-pop-view">
        <img class="tip-pop" src="../../assets/ios_browser_tips.png" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      show: false,
      imgUrl: `https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/jinrong/wechat-bg.jpg?t=${Date.now()}`
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    download() {
      if (this.isWeixin()) {
        this.show = true;
        return;
      }
      window.open('http://zhxt.eastfair.com/79818698966');
    },
    download_two () {
      if (this.isWeixin()) {
        this.show = true;
        return;
      }
      window.open('http://zhxt.eastfair.com/79837537982');
    },
    openApp() {
      if (this.isWeixin()) {
        this.show = true;
        return;
      }
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) { //判断是否是iOS
        window.location.href = "iexhibitionjinrong://open";
      }
      if (navigator.userAgent.match(/android/i)) { //判断是否是Android
        // window.location.href = "weixin://open";
        window.location.href = "iexhibitionjinrongzhan://eastfair";
      }      
    },
    isWeixin () { //判断是否是微信
      var ua = navigator.userAgent.toLowerCase();
      return ua.match(/MicroMessenger/i) == "micromessenger";
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) { //判断是否是iOS
      window.location.href = "iexhibitionjinrong://open";
    }
    if (navigator.userAgent.match(/android/i)) { //判断是否是Android
      window.location.href = "iexhibitionjinrongzhan://eastfair";
      // window.location.href = "weixin://open";
    }
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.dl-view {
  position: relative;
  text-align: center;
  background-color: #f00000;
  height: 100vh;
  /* background-image: url('https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/jinrong/wechat-bg.png');
  background-size: cover;
  background-repeat: no-repeat; */
}
.open-app-view {
  margin: 0 auto;
  text-align: center;
  margin-left: 30px;
  margin-right: 30px;
  height: 44px;
  line-height: 44px;
  background: linear-gradient(124deg, #FBF776 0%, #FFE13A 52%, #FDE140 100%);
  border-radius: 22px;
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #D00303;
  margin-top: 20px;
}
.download-app-view {
  margin: 0 auto;
  text-align: center;
  margin-left: 30px;
  margin-right: 30px;
  height: 44px;
  line-height: 44px;
  border-radius: 22px;
  border: 2px solid #FFE13A;
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFE139;
  margin-top: 21px;
}
.tip-pop-view {
  position: relative;
}
.tip-pop {
  position: absolute;
  width: 250px;
  right: 20px;
  top: 20px;
}
.download-button-view {
  position: absolute;
  bottom: 49px;
  width: 100%;
  text-align: center;
}
</style>
